export default {
    impression : 'impression',
    ddx : 'ddx',
    maleFactor : 'Male Factor',
    femaleFactor : 'Female Factor',
    prescription : 'Prescription',
    clinicSonographies : 'Clinic Sonographies',
    drugName : 'Drug Name',
    dosageOfTheDrug : 'Dosage Of TheDrug',
    durationOfMedication : 'Duration Of Medication',
    count : 'Count',
    medicationHours : 'Medication Hours',
    date : 'Date',
    description : 'Description',
    sonographyAndLab : 'Sonography And Lab',
    plan : 'Plan',
    artType : 'ART Type',
    urology : 'Urology',
    genetic : 'Genetic',
    pgd : 'PGD',
    pgs : 'PGS',
    generalSurgery  : 'General Surgery',
    surgeryType  : 'Surgery Type',
    surgery  : 'Surgery',
    time  : 'Time',
    midwife  : 'Midwife',
    dr  : 'Doctor',
    clinicSonographyType  : 'Clinic Sonography Type',
    referType  : 'Refer Type',
    referRole  : 'Refer Role',
    referDescription  : 'Refer Description',
    print  : 'Print',
    nextAppointment  : 'Next Appointment',
    complaintAndAssessment  : 'Complaint And Assessment',
    referenceTo  : 'Reference To',
    nextVisit  : 'Next Visit',
    visitDate  : 'Visit Date',
    showVisitItems  : 'Show Visit Items',
    pgdReason  : 'PGD Reason',
    genderType  : 'Gender Type',
    antenatalCareTests  : 'Antenatal Care Tests',
    fileTo  : 'Refer To Medical Record',
    reasonOfReference  : 'Reason Of Reference',
    reasonOfReferenceField  : 'Reason Of Reference',
    specialty  : 'Specialty',
    fromDoctorUser  : 'From Doctor',
}